import { TOGGLE_CHECKED, SET_RECEIVER_ID, SET_CHECKED_FALSE } from "./types";

// Initial state
const initialState = {
  isChecked: false, // This will represent showBalance
  receiverId: null, // Stores the receiver_id
  selectAllChecked: false, // Separate state for select all checkbox
};

// Reducer to handle toggle state
const toggleReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_CHECKED:
      return {
        ...state,
        isChecked: !state.isChecked,
      };
    case SET_RECEIVER_ID:
      return {
        ...state,
        receiverId: action.payload,
      };
    case SET_CHECKED_FALSE:
      return {
        ...state,
        isChecked: false,
      };
    default:
      return state;
  }
};

export default toggleReducer;